module.exports = __webpack_public_path__ + "img/product_72.c89fc82.svg";